import { gql } from '@apollo/client'

export const SENTIMENT_GROUP_DISTRIBUTION_FRAGMENT = gql`
  fragment SentimentGroupDistribution on MentionGroup {
    bySentiment: groups(aggregate: SENTIMENT) {
      count
      ... on SentimentGroup {
        sentiment
      }
    }
  }
`

export const LOCATION_RANKING_SENTIMENT_DATA_FRAGMENT = gql`
  fragment LocationRankingSentimentData on LocationRankingSentiment {
    sentiment
    count
  }
`

export const LOCATION_RANKING_GROUP_DATA_FRAGMENT = gql`
  fragment LocationRankingGroupData on LocationRankingGroup {
    location {
      id
      name
      locality
      address
      metadata {
        key
        value
      }
    }
    reviewsCount
    prevReviewsCount
    avgRating
    prevAvgRating
    sentiments {
      ...LocationRankingSentimentData
    }
    feed {
      id
      name
      avatarUrl
    }
  }
  ${LOCATION_RANKING_SENTIMENT_DATA_FRAGMENT}
`

export const LOCATION_BY_REGION_GROUP_FRAGMENT = gql`
  fragment LocationByRegionGroupData on LocationByRegionGroup {
    region
    reviewsCount
    prevReviewsCount
    avgRating
    prevAvgRating
    sentiments {
      ...LocationRankingSentimentData
    }
    locations {
      ...LocationRankingGroupData
    }
  }
  ${LOCATION_RANKING_SENTIMENT_DATA_FRAGMENT}
  ${LOCATION_RANKING_GROUP_DATA_FRAGMENT}
`
